import { Box, Link, Typography, Grid2 } from '@mui/material';

export default function Learn() {
  return (
    <Box
      width="100%"
      sx={{
        minHeight: '90vh',
        display: 'flex',
        flexDirection: 'column'
      }}
      px={{ xs: 2, sm: 3, md: 4 }}
    >
      <Grid2
        container
        width="100%"
        rowSpacing={{ xs: 2, md: 4 }}
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
      >
        <Grid2 size={{ xs: 12, md: 8 }}>
          <Typography
            sx={{
              fontFamily: 'Outfit',
              fontWeight: 600,
              fontSize: { xs: '2rem', md: '2.5rem' },
              lineHeight: 1.25,
              background: 'linear-gradient(0deg, #FFFFFF 0%, #2983E2 200%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              textFillColor: 'transparent',
              my: 4
            }}
          >
            rUSDC: Cross-Chain Lending Solution
          </Typography>
        </Grid2>

        <Grid2 size={{ xs: 12, sm: 10, md: 8 }}>
          <Box
            sx={{
              bgcolor: 'rgba(1, 171, 146, 0.12)',
              borderRadius: '1.5625rem',
              p: 3,
              mb: 3,
              boxShadow: '0 8px 32px rgba(1, 171, 146, 0.15)',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-5px)',
                boxShadow: '0 12px 40px rgba(1, 171, 146, 0.25)'
              }
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: 'rgba(4, 255, 218, 0.9)',
                mb: 2,
                fontWeight: 600,
                fontSize: { xs: '1.2rem', md: '1.3rem' }
              }}
            >
              What is rUSDC?
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: 'white',
                mb: 3,
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.6,
                borderLeft: '3px solid rgba(4, 255, 218, 0.5)',
                pl: 2
              }}
            >
              rUSDC is a collection of USDC wrappers that enables lending market risk curators to relend Ethereum
              mainnet TVL to other chains. Users can mint rUSDC on Ethereum by supplying USDC, bridge it to partner
              chains, and access ecosystem incentives.
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: 'rgba(4, 255, 218, 0.9)',
                mb: 2,
                fontWeight: 600,
                fontSize: { xs: '1.2rem', md: '1.3rem' }
              }}
            >
              How It Works
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: 'white',
                mb: 3,
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.6,
                borderLeft: '3px solid rgba(4, 255, 218, 0.5)',
                pl: 2
              }}
            >
              The system utilizes innovative price stability modules (both local and global) to maintain the peg to
              USDC. Risk is segregated between different chains, offering protection against chain-specific failures.
              <br />
              In a case where there is an issue with rUSDC-X chain, the local price stability module on rUSDC-Y chain is
              not affected.
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: 'rgba(4, 255, 218, 0.9)',
                mb: 2,
                fontWeight: 600,
                fontSize: { xs: '1.2rem', md: '1.3rem' }
              }}
            >
              Important Risk Information
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: 'white',
                mb: 3,
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.6,
                bgcolor: 'rgba(255, 255, 255, 0.05)',
                p: 2,
                borderRadius: '0.5rem'
              }}
            >
              While designed with multiple safeguards, users should be aware of potential risks including smart contract
              vulnerabilities, chain-specific issues, lending market insolvency, and curator-related risks.
            </Typography>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 3,
                pt: 2,
                borderTop: '1px solid rgba(255, 255, 255, 0.1)'
              }}
            >
              <Link
                href="https://docs.relend.network/relend.docs/rusdc-mechanism-and-risk-disclosure"
                target="_blank"
                sx={{
                  color: 'rgba(4, 255, 218, 1)',
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: 600,
                  py: 1,
                  px: 3,
                  borderRadius: '2rem',
                  bgcolor: 'rgba(4, 255, 218, 0.1)',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    bgcolor: 'rgba(4, 255, 218, 0.2)',
                    transform: 'scale(1.05)'
                  }
                }}
              >
                <strong>Read the full mechanism and risk disclosure</strong>
              </Link>
            </Box>
          </Box>
        </Grid2>
      </Grid2>

      <Box
        display="flex"
        flexDirection="column"
        justifyContent="flex-end"
        sx={{
          mt: 'auto',
          mb: 0
        }}
      >
        <Typography variant="subtitle2" align="center">
          <small>Version: {import.meta.env.VITE_GIT_HASH || 'development'}</small>
        </Typography>
      </Box>
    </Box>
  );
}
